export default __webpack_public_path__ + "static/media/logo-artmind.b100010e.jpg";